import React from "react";

import { Alert } from "./Alert";

interface PageLoadErrorProps {
  message: string;
  onRetry: () => unknown;
  isRetrying?: boolean;
  className?: string;
}

export const PageLoadError: React.FC<PageLoadErrorProps> = ({
  message,
  onRetry,
  isRetrying = false,
  className = "min-h-screen p-4",
}) => {
  return (
    <div className={className}>
      <div className="max-w-6xl mx-auto space-y-4">
        <Alert type="error" message={message} />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-outline"
            onClick={() => void onRetry()}
            disabled={isRetrying}
          >
            {isRetrying ? "Retrying..." : "Retry"}
          </button>
        </div>
      </div>
    </div>
  );
};